import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type contractsDataType = {
  id: string;
  endpoint: string;
  errorCallback: Function;
  successCallback?: Function;
  resultKey?: string;
};

export default ({ id, endpoint, errorCallback, resultKey, successCallback }: contractsDataType) =>
  requestAsync({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    url: endpoints[`${endpoint}UrlV2`](id),
    transform: (response) => ({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: {
        contracts: response,
      },
    }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    queryKey: endpoints[endpoint](id),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
